import { toast } from "react-toastify";
import { fetchRequestWrapper } from "@/lib/utilities";
import { logClientError } from "@/lib/errorLoggingACTIONS";
import { HelpdeskSeverity } from "@/lib/interfaces and Enums/ENUMHelpdeskSeverity";

export async function submitHelpdeskTicket({
  severity,
  message,
  getAccessTokenSilently,
}: {
  severity: HelpdeskSeverity;
  message: string;
  getAccessTokenSilently: any;
}): Promise<boolean> {
  if (!message.trim()) {
    toast.error("Please provide a description before submitting.");
    return false;
  }

  try {
    const response = await fetchRequestWrapper(
      { url: "/Helpdesk", method: "POST", objToSend: { severity, message } },
      getAccessTokenSilently,
    );
    toast.success(
      `Request sent. Ticket #${response.helpdeskId}. A confirmation has been emailed to you.`,
    );
    return true;
  } catch (error) {
    // fetchRequestWrapper has already toasted the failure.
    logClientError("HelpdeskForm", error, getAccessTokenSilently);
    return false;
  }
}
